module.exports = __webpack_public_path__ + "media/images/payments/paypal-4f49ee16126497f056a428b5ace16e4f.svg";